export default "__VITE_ASSET__BJN8bP1p__"